import {putMethod} from '~/api'

async function put(groupId, request) {
    return await putMethod(`/api/modifySchedulerGroup/${groupId}`, request)
}

export {put}
